/**
* Author: JJ Li
* Date: 2020/04/14
*/

import { v4 as uuidv4 } from "uuid";
import crypto from "./crypto";

// check browser supports Local storage
const localStorage = {
  canWriteStorage: () => {
    try {
      window.localStorage.setItem("_canWriteToLocalStorage", 1);
      window.localStorage.removeItem("_canWriteToLocalStorage");
      return true;
    } catch (e) {
      return false;
    }
  },
  get: key => {
    return window.localStorage.getItem(key);
  },
  set: (key, value) => {
    return window.localStorage.setItem(key, value);
  },
  remove: key => {
    return window.localStorage.removeItem(key);
  }
};

let sidKey = "NxVet-sid";

const storage = {
  canWrite: false,
  sid: "",
  init: () => {
    storage.canWrite = localStorage.canWriteStorage();
    if (!storage.canWrite)
      return console.log("your browser not support localStorage.");

    storage.getSid();
  },
  getSid: () => {
    storage.sid = localStorage.get(sidKey);
    if (storage.sid) return;

    storage.sid = uuidv4();
    localStorage.set(sidKey, storage.sid);
    return;
  },
  get: (key, defaultValue = null) => {
    if (!storage.canWrite) return null;

    const value = localStorage.get(key);
    if (!value) return defaultValue;

    return JSON.parse(value);
  },
  set: (key, value) => {
    if (!storage.canWrite) return null;

    return localStorage.set(key, JSON.stringify(value));
  },
  remove: (key) => {
    if (!storage.canWrite) return null;
    return localStorage.remove(key);
  },
  getWithEncrypt: (key, defaultValue = null) => {
    if (!storage.canWrite) return null;

    // Encrypt
    const newKey = key + "-" + storage.sid;
    const enKey = crypto.encrypt(newKey, storage.sid);

    const enValue = localStorage.get(enKey);

    if (enValue === null || enValue === "" || typeof enValue === "undefined")
      return defaultValue;

    return JSON.parse(crypto.decrypt(enValue, storage.sid));
  },
  setWithEncrypt: (key, value) => {
    if (!storage.canWrite) return null;

    // Encrypt
    const newKey = key + "-" + storage.sid;
    const enKey = crypto.encrypt(newKey, storage.sid);
    const enValue = crypto.encrypt(JSON.stringify(value), storage.sid);

    return localStorage.set(enKey, enValue);
  },
  removeWithEncrypt: (key) => {
    if (!storage.canWrite) return null;

    const newKey = key + "-" + storage.sid;
    const enKey = crypto.encrypt(newKey, storage.sid);
    return localStorage.remove(enKey);
  },
  getWithEncryptAndExpiry: (key, defaultValue = null) => {
    if (!storage.canWrite) return null;

    // Encrypt
    const newKey = key + "-" + storage.sid;
    const enKey = crypto.encrypt(newKey, storage.sid);

    let item = localStorage.get(enKey);
    if (!item) return defaultValue;

    item = JSON.parse(item);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      storage.removeWithEncrypt(key);
      return defaultValue;
    }

    return JSON.parse(crypto.decrypt(item.value, storage.sid));
  },
  setWithEncryptAndExpiry: (key, value, expiry = 259200) => {
    if (!storage.canWrite) return null;

    // Encrypt
    const newKey = key + "-" + storage.sid;
    const enKey = crypto.encrypt(newKey, storage.sid);
    const now = new Date()
    const item = {
      value: crypto.encrypt(JSON.stringify(value), storage.sid),
      expiry: now.getTime() + (expiry * 1000)
    };

    return localStorage.set(enKey, JSON.stringify(item));
  }
};

export default storage;
